module.exports = __webpack_public_path__ + "images/mastercard-60b7c5.svg";